import { render, staticRenderFns } from "./JudgePanel.vue?vue&type=template&id=c7fdcba8&scoped=true"
import script from "./JudgePanel.vue?vue&type=script&lang=js"
export * from "./JudgePanel.vue?vue&type=script&lang=js"
import style0 from "./JudgePanel.vue?vue&type=style&index=0&id=c7fdcba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdcba8",
  null
  
)

export default component.exports